<template>
  <div class="login-container" :style="{ backgroundImage: `url(${require('@/assets/bg.png')})` }">
    <div style="text-align: center">
      <img style="width: 100px;margin-top: 18%" src="@/assets/logo.26f5.png" alt="logo">
    </div>
    <div style="text-align: center">
      <img style="width:110%;margin-top: 0px" src="@/assets/title.a8f8.png" alt="logo">
    </div>

    <!-- 主登录区域 -->
    <div class="login-main" v-if="infoType == 0">
      <div class="login-form">
        <div class="left" style="background-color: #CDC9D6">
          <div class="text" style="color: #5a4c5b">登录</div>

          <div class="input" style="padding: 8px 15px;background-color: #fff;border-radius: 30px;">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user" class="svg-inline--fa fa-user " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="margin: 0px 4px;color: #9C658E;width: 16px"><path fill="currentColor" d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"></path></svg>
            <input v-model="loginInfo.name"  type="text" placeholder="输入用户名">
          </div>

          <div class="input" style="padding: 8px 15px;background-color: #fff;border-radius: 30px;margin-bottom: 0px">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="key" class="svg-inline--fa fa-key " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="margin: 0px 4px;color:#9C658E;width: 16px"><path fill="currentColor" d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"></path></svg>
            <input v-model="loginInfo.password" :type="showPassword ? 'text' : 'password'" placeholder="输入登录密码">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="eye" class="svg-inline--fa fa-eye show-pass" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style="margin: 0px 4px;color: #9C658E;width: 16px" @click.stop="showPassword = !showPassword"><path fill="currentColor" d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"></path></svg>
          </div>

          <div class="user-agreement" @click="agreementChecked = !agreementChecked">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="square-check" class="svg-inline--fa fa-square-check " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="margin: 0px 4px 0px 4px;color: #9C658E;width: 12px"><path fill="currentColor" d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path></svg>
            我已阅读并同意
            <span style="color: #9c6490;">《游戏网站使用者条款》</span>
          </div>

          <div class="submit" @click="handleLogin">登 录</div>

          <div class="others">
            <div @click="guestLogin">先去逛逛</div>
            <div @click="showCustomerService">在线客服</div>
          </div>
        </div>

        <div class="right"  @click="changInfoType(1)"   style="background-color: #5B4D5D;">
          <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="circle-user" class="svg-inline--fa fa-circle-user " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="color: #ffffff;width: 20px"><path fill="currentColor" d="M406.5 399.6C387.4 352.9 341.5 320 288 320H224c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3h64c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"></path></svg>
          <span style="color: #ffffff">注</span>
          <span style="color: #ffffff">册</span>
          <span style="color: #ffffff">新</span>
          <span style="color: #ffffff">用</span>
          <span style="color: #ffffff">户</span>
        </div>
      </div>
    </div>

    <div class="login-main" v-else-if="infoType == 1">
      <div class="login-form">
        <div class="left" style="background-color: #CDC9D6">
          <div class="text" style="color: #5a4c5b">注册</div>

          <div class="input" style="padding: 8px 15px;background-color: #fff;border-radius: 30px;">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user" class="svg-inline--fa fa-user " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="margin: 0px 4px;color: #9C658E;width: 16px"><path fill="currentColor" d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"></path></svg>
            <input v-model="registerInfo.name" type="text" placeholder="用户名为6-12位">
          </div>

          <div class="input" style="padding: 8px 15px;background-color: #fff;border-radius: 30px;">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="key" class="svg-inline--fa fa-key " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="margin: 0px 4px;color:#9C658E;width: 16px"><path fill="currentColor" d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"></path></svg>
            <input v-model="registerInfo.password" :type="showPassword ? 'text' : 'password'" placeholder="密码为6-16位">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="eye" class="svg-inline--fa fa-eye show-pass" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style="margin: 0px 4px;color: #9C658E;width: 18px" @click.stop="showPassword = !showPassword"><path fill="currentColor" d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"></path></svg>
          </div>

          <div class="input" style="padding: 8px 15px;background-color: #fff;border-radius: 30px;margin-bottom: 0px">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="key" class="svg-inline--fa fa-key " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="margin: 0px 4px;color:#9C658E;width: 16px"><path fill="currentColor" d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0S160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V448h40c13.3 0 24-10.7 24-24V384h40c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z"></path></svg>
            <input v-model="registerInfo.paypassword" :type="showPasswords ? 'text' : 'password'" placeholder="支付密码为6-16位">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="eye" class="svg-inline--fa fa-eye show-pass" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" style="margin: 0px 4px;color: #9C658E;width: 16px" @click.stop="showPasswords = !showPasswords"><path fill="currentColor" d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"></path></svg>
          </div>

          <div class="user-agreement" @click="agreementChecked = !agreementChecked">
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="square-check" class="svg-inline--fa fa-square-check " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="margin: 0px 4px 0px 4px;color: #9C658E;width: 12px"><path fill="currentColor" d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"></path></svg>
            我已阅读并同意
            <span style="color: #9c6490;">《游戏网站使用者条款》</span>
          </div>

          <div class="submit" @click="handlerRegister">注册</div>

          <div class="others">
            <div @click="guestLogin">先去逛逛</div>
            <div @click="showCustomerService">在线客服</div>
          </div>
        </div>

        <div class="right" @click="changInfoType(0)"  style="background-color: #5B4D5D;">
          <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="circle-user" class="svg-inline--fa fa-circle-user " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="color: #ffffff;width: 20px"><path fill="currentColor" d="M406.5 399.6C387.4 352.9 341.5 320 288 320H224c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3h64c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"></path></svg>
          <span style="color: #ffffff">返</span>
          <span style="color: #ffffff">回</span>
          <span style="color: #ffffff">登</span>
          <span style="color: #ffffff">录</span>
        </div>
      </div>
    </div>

    <div class="global-overlay" :class="{ hidden: !showOverlay }" :style="{ zIndex: overlayZIndex }"></div>

    <div v-if="show_msg_app" class="fg6ZfskHOnqaRwP2znAd block global-overlay" style="z-index: 200;">
      <div class="CcZmMdYWZeh7OF0CJm6z center-contents undefined">
        <div class="header">
          <div style="font-size: 18px;">认证失败</div>
        </div>
        <div class="contents">您的账号登陆过期，请重新登陆</div>
        <div class="actions">
          <button @click="show_msg_app = false"   color="secondary">确认</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

export default {
  name: 'LoginPage',

  data() {
    return {
      show_msg_app:false,
      loginInfo: {
        name:'',
        password:'',
      },
      infoType: 0, //0 是登陆 1是注册
      registerInfo: {},
      pid: '',
      index: 0,

      psw1: true,
      psw2: true,
      psw3: true,


      username: '',
      password: '',
      showPasswords: false,
      showPassword: false,
      rememberPassword: false,
      agreementChecked: true,
      showOverlay: false,
      overlayZIndex: 0,
      showCaptcha: false,
      x: 323,
      y: 710,
      dragging: false,
      startX: 0,
      startY: 0,
      pos: {
      }
    }
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if(query.token_msg && query.token_msg == 1){
        this.show_msg_app = true;
    }


    if (query.type) {
      that.infoType = query.type;
    }
    if (query.pid) {
      that.pid = query.pid;
    }
    that.changIndex();
  },
  methods: {
    showForgotPassword(){},

    changPsw(name) {
      this[name] = !this[name];
    },
    changInfoType(type) {
      let that = this;
      if (that.infoType == type) {
        return;
      }
      that.infoType = type;
      that.changIndex();
      that.loginInfo = {};
      that.registerInfo = {};
      this.psw1 = true;
      this.psw2 = true;
      this.psw3 = true;
    },
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    handlerRegister() {
      let that = this;

      let info = that.registerInfo;
      console.log(info);
      if (!info.name || info.name.length < 6) {
        that.$parent.showTost(0, ' 用户名长度6~16位，以字母或数字组合！');
        return;
      }
      if (!info.password || info.password.length < 6) {
        that.$parent.showTost(0, '请输入正确的密码长度，最少6位！');
        return;
      }

      if (!info.paypassword || info.paypassword.length < 6) {
        that.$parent.showTost(0, '请输入正确的支付密码长度，最少6位！');
        return;
      }
      let code = that.registerInfo.code;

      that.$parent.showLoading();
      if (that.pid) {
        info.pid = that.pid;
      }
      info.realname = '无';
      that.$apiFun.register(info).then(res => {
        that.$parent.showTost(1, res.message);
        if (res.code == 200) {
          localStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();

          that.$parent.goNav('/');
        }
        that.$parent.hideLoading();
      });
    },
    handleLogin() {
      let that = this;
      let info = that.loginInfo;
      if (!info.name || !info.password) {
        that.$parent.showTost(0, '请输入您的账号和密码！');
        return;
      }
      let code = that.loginInfo.code;


      that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
          that.$parent.hideLoading();
        }
        if (res.code === 200) {
          localStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();

          that.$parent.goNav('/');
        }
        that.$parent.hideLoading();
      });
    },
    guestLogin(){
      this.$parent.goNav('/');
    },
    showCustomerService(){
      this.$parent.goNav('/kefu');
    },
  }

}
</script>

<style scoped>

.login-container {

  margin: 0;
  padding: 0;
  min-height: 100%;

  background-size: 100% auto;  /* 宽度100%，高度自动 */
  background-position: center top;
  background-repeat: no-repeat;
  background-attachment: fixed;  /* 可选 - 固定背景 */



  background-size: contain; /* 关键属性 - 确保图片完整显示 */
  background-position: center;
  background-repeat: no-repeat;

  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  height: 100vh;
  //width: 100vh;
  //background-size: contain;  /* 关键属性 - 完整显示图片 */
  //background-position: center;
  background-repeat: no-repeat;
  //background-color: #000;  /* 图片未覆盖区域的背景色 */
  background-color: #f5f5f5;

  background-position: center center;

  background-repeat: no-repeat;

  background-size: cover;


}

.floating-icon {
  position: absolute;
  width: 36px;
  height: 36px;
  cursor: move;
  z-index: 100;
}

.floating-icon .icon {
  width: 100%;
  height: 100%;
}

.login-main {
  //display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding:0px 14px 0px 18px;
  box-sizing: border-box;
}

.logo, .title {
  /* 这里应该是你的logo和标题样式 */
  margin-bottom: 20px;
}

.login-form {
  display: flex;
  width: 100%;
  max-width: 800px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.left {
  flex: 1;
  padding: 13px 13px  4px 13px;
}

.right {
  width: 42px;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
}

.right:hover {
  background: #e9e9e9;
}

.right svg {
  font-size: 50px;
  color: #4eccc4;
  margin-bottom: 10px;
}

.right span {
  font-size: 18px;
  color: #333;
}

.text {
  text-align: center;
  font-size: 18px;
  //font-weight: bold;
  margin-bottom: 8px;
  //color: #333;
}

.input {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding: 10px 0;
}

.input svg {
  margin: 0 10px;
  color: #888;
}

.input input {
  width: 80%;
  flex: 1;
  border: none;
  outline: none;
  font-size: 18px;
  padding: 5px;
}

.show-pass {
  cursor: pointer;
  color: #888;
}

.remember {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 14px;
  color: #666;
}

.remember div {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.remember svg {
  margin-right: 5px;
}

.forgot {
  color: #4eccc4;
  cursor: pointer;
}

.user-agreement {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 12px;
  color: #666;
  cursor: pointer;

}

.user-agreement svg {
  margin-right: 2px;
}

.user-agreement span:last-child {
  color: #4eccc4;
  margin-left: 2px;
}

.submit {
  border-radius: 44px;

  background-image:linear-gradient(47deg, #593f6c, #a16793);
  height:44px;
  width: 100%;

  box-sizing: border-box;
  border: none;
  font-weight: 700;

  //font-size: 0.8533rem;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;

  //width: 100%;
  //padding: 12px;
  ////background: #4eccc4;
  //color: white;
  //border: none;
  ////border-radius: 5px;
  font-size: 18px;
  //cursor: pointer;
  //transition: background 0.3s;
}

.submit:hover {
  //background: #3dbdb5;
}

.others {
  display: flex;
  justify-content: space-between;
  margin-top: 0px;
  font-size: 14px;
  color: #666;
}

.others div {
  cursor: pointer;
  padding: 5px 10px;
}

.others div:hover {
  color: #4eccc4;
}

.global-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 999;
}

.global-overlay.hidden {
  display: none;
}

#captcha-wy {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999;
}





.fg6ZfskHOnqaRwP2znAd {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, .6);
  top: 0;
  left: 0;
  position: fixed;
  //transform: translateZ(500px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.CcZmMdYWZeh7OF0CJm6z {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: fixed;
  animation: fade-bottom-top .6s forwards;
  width: calc(100% - 2.67rem);
  max-height: calc(100% - 3.41rem);
  background: url(/webx/xc/mobile/svg/popup-bg.368d.svg);
  background-size: contain;
  height: 7.467rem;
  height: 291px;
}


.CcZmMdYWZeh7OF0CJm6z {
  background: url(/webx/xc/mobile/images/outcache/popup-bg.08e4.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-size: 95% auto;
  background-position: center;
  background-repeat: no-repeat;
}

.CcZmMdYWZeh7OF0CJm6z .header {
  padding: 0 1.066667rem;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  margin-top: 5.3rem;
}

.CcZmMdYWZeh7OF0CJm6z>.header {
  margin-top: 80px;
}

.CcZmMdYWZeh7OF0CJm6z .contents {
  min-height: 2rem;
  //max-height: 1rem;
  overflow: auto;
  box-sizing: border-box;
  padding: 10px 8px;
  font-size: 18px;
  line-height: 1.066667rem;
  text-align: center;
  color: rgba(47, 39, 71, .6);
  word-break: break-all;
}

.center-contents .contents {
  display: flex;
  justify-content: center;
  align-items: center;
}

.CcZmMdYWZeh7OF0CJm6z .actions {
  overflow: hidden;
  display: flex;
  justify-content: center;
  padding-bottom: .5333rem;
  border-radius: .5333rem;
  background-color: rgba(0, 0, 0, 0) !important;
}

.CcZmMdYWZeh7OF0CJm6z>.actions {
  background-color: #fff;
}

.CcZmMdYWZeh7OF0CJm6z .actions>button {
  width: 2.9733rem;
  height: 1rem;
  color: #fff;
  margin: 0 .2667rem;
  background: url(/webx/xc/mobile/svg/confirm.8bcf.svg) no-repeat;
  background-size: contain;
  border-color: rgba(0, 0, 0, 0);
  font-size: .4533rem;

}



.CcZmMdYWZeh7OF0CJm6z .actions>button.cancel {
  background: url(/webx/xc/mobile/svg/cancel.af39.svg) no-repeat;
  background-size: contain;
  color: #9f9f9f;
}


</style>